module.exports = __webpack_public_path__ + "img/image-01.80e958bb.webp";